/* eslint-disable @typescript-eslint/no-explicit-any */ import { T } from "@supersig/validate";
import { automatableValueTypes, automatableValueTypesAndDefaultPropogation } from "../../primitives";
import { opacityValidator } from "../misc/SWOpacity";
import { idValidator } from "../misc/id-validator";
/** @public */ export const parentIdValidator = T.string.refine((id)=>{
    if (!id.startsWith("page:") && !id.startsWith("node:")) {
        throw new Error('Parent ID must start with "page:" or "node:"');
    }
    return id;
});
/** @public */ export const nodeIdValidator = idValidator("node");
/** @public */ export function createNodeValidator(type, props, meta) {
    return T.object({
        id: nodeIdValidator,
        typeName: T.literal("node"),
        x: T.number,
        y: T.number,
        rotation: T.number,
        index: T.string,
        parentId: parentIdValidator,
        type: T.literal(type),
        isLocked: T.boolean,
        opacity: opacityValidator,
        props: props ? T.object(props) : T.jsonValue,
        name: T.string.optional(),
        isHidden: T.boolean.optional(),
        clickBehavior: T.jsonValue.optional(),
        defaultProperties: T.dict(T.string, automatableValueTypes.nullable()),
        properties: T.dict(T.string, automatableValueTypesAndDefaultPropogation),
        meta: meta ? T.object(meta) : T.jsonValue,
        requiredRecordIds: T.arrayOf(T.string)
    });
}
